import * as Yup from 'yup';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';

export const passwordMinimumLimit2024 = {
  value: 16,
  message: 'Password must be at least 16 characters long',
};

export const passwordMinimumLimitDevelopment = {
  value: 4,
  message: 'Password must be at least 4 characters long',
};

export const passwordMaximumLimit = {
  value: 64,
  message: 'Password must not be longer then 64 characters',
};

export const dropdownSchema: Yup.Schema<DropdownOption> = Yup.object({
  key: Yup.string().required(),
  value: Yup.string().required(),
  label: Yup.string().required(),
  disabled: Yup.boolean().optional(),
});
